import { Jump } from './Jump';
export class Jmp extends Jump {
    constructor(op, pc) {
        super(op, pc);
    }
    plus(pc) {
        return new Jmp(this.op, this.pc.plus(pc));
    }
}

//# sourceMappingURL=Jmp.js.map
